require('lib/browser_required')('module/viewport/viewport')

const Viewport = require('module/viewport/viewport_model')

module.exports = new Viewport()
